"use strict";
export var ExtensionEventName = /* @__PURE__ */ ((ExtensionEventName2) => {
  ExtensionEventName2["BackgroundAttemptedToOpenSidebar"] = "Background Attempted To Open Sidebar";
  ExtensionEventName2["ChangeLockedState"] = "Change Locked State";
  ExtensionEventName2["DappChangeChain"] = "Dapp Change Chain";
  ExtensionEventName2["DappConnect"] = "Dapp Connect";
  ExtensionEventName2["DappConnectRequest"] = "Dapp Connect Request";
  ExtensionEventName2["DappDisconnect"] = "Dapp Disconnect";
  ExtensionEventName2["DappDisconnectAll"] = "Dapp Disconnect All";
  ExtensionEventName2["DappRequest"] = "Dapp Request";
  ExtensionEventName2["DappTroubleConnecting"] = "Dapp Trouble Connecting";
  ExtensionEventName2["DeprecatedMethodRequest"] = "Deprecated Method Request";
  ExtensionEventName2["ExtensionEthMethodRequest"] = "Extension Eth Method Request";
  ExtensionEventName2["OnboardingLoad"] = "Onboarding Load";
  ExtensionEventName2["PasswordChanged"] = "Password Changed";
  ExtensionEventName2["ProviderDirectMethodRequest"] = "Provider Direct Method Request";
  ExtensionEventName2["SidebarClosed"] = "Sidebard Closed";
  ExtensionEventName2["SidebarDisconnect"] = "Sidebar Disconnect";
  ExtensionEventName2["SidebarLoad"] = "Sidebard Load";
  ExtensionEventName2["SidebarSwitchChain"] = "Sidebar Switch Chain";
  ExtensionEventName2["UnknownMethodRequest"] = "Unknown Method Request";
  ExtensionEventName2["UnsupportedMethodRequest"] = "Unsupported Method Request";
  ExtensionEventName2["UnrecognizedMethodRequest"] = "Unrecognized Method Request";
  return ExtensionEventName2;
})(ExtensionEventName || {});
